/* eslint-disable @typescript-eslint/no-explicit-any */
import { AuthService } from '../auth/AuthService';
import { ApiBack } from '../axios-config';

// export interface IAnomalias {
// 	acao: string;
// 	area_responsavel: string;
// 	data_criacao?: string;
// 	data_inspecao: string;
// 	descricao_anomalia: string;
// 	descricao_atividades: string;
// 	id_barragem: string;
// 	matricula_responsavel_procedimento: string;
// 	nome_responsavel_procedimento: string;
// 	npa: string;
// 	observacoes_gerais: string;
// 	prazo_previsto_fim: string;
// 	prazo_previsto_inicial: string;
// 	prazo_real_fim?: string | null;
// 	prazo_real_inicial?: string | null;
// 	relatorio_inspecao: string;
// 	uo_responsavel_procedimento: string;
// 	uuid?: string;
// 	file?: File | string;
// 	titulo: string,
// 	magnitude: string,
// 	estrutura: string,
// 	nome_arquivo?: string,
// 	data_armazenamento?: string,
// 	historico?: any,
// 	reservatorio_seco?: boolean,
// 	vertimento_extravasor?: boolean,
// 	fluxo_dreno?: boolean,
// 	situacao: string,
// }



export interface IActionPlanSummary {
	uuid: string;
	acao: string;
	codigo_anomalia: string;
	atualizado_em?: string | null;
	data_criacao: string;
	data_limite_seguranca: string;
	descricao: string;
	finalizado: boolean;
	id_anomalia: string;
	id_barragem: string;
	npa: string;
	responsavel_principal: string;
	origem: string,
	anomalia?: IDetalhesAnomalia;
	status?: 'NAO INICIADO' | 'EM ANDAMENTO' | 'FINALIZADO'
}

export interface IDetalhesAnomalia {
	data_inspecao: string;
	item: string;
	situacao: string;
	magnitude: string;
	npa: string;
	observacoes_gerais: string;
	vertimento_extravasor?: boolean;
	fluxo_dreno?: boolean;
	reservatorio_seco?: boolean;
	uuid?: string;
	historico?: IDetalhesAnomalia[];
	fluxo: boolean;
	id_estrutura?: string;
	plano_acao?: IActionPlanSummary[] | null;
	origem?: string;
	codigo_anomalia?: string;
}

export interface IImagemAnomalia {
	data: string;
	legenda?: string;
	observacoes?: string;
	date: string;
	nome?: string; 
}

export interface IAnomalias {
	uuid?: string;
	data_armazenamento?: string;

	estrutura: string;
	id_barragem: string;

	detalhes: IDetalhesAnomalia[];
	imagens: IImagemAnomalia[];

	acao?: string;
	area_responsavel?: string;
	descricao_atividades?: string;
	matricula_responsavel_procedimento?: string;
	nome_responsavel_procedimento?: string;
	prazo_previsto_fim?: string;
	prazo_previsto_inicial?: string;
	prazo_real_fim?: string;
	prazo_real_inicial?: string;
	relatorio_inspecao?: string;
	uo_responsavel_procedimento?: string;

	file?: File | string;
	nome_arquivo?: string;
	historico?: IAnomalias[];
	codigo_anomalia?: string;
	origem?: string;
}


export interface IAnomaliasPut {
	uuid?: string;
	data_armazenamento?: string;

	estrutura: string;
	id_barragem: string;

	detalhes: IDetalhesAnomalia;
	imagens: IImagemAnomalia[] | undefined;

	acao?: string;
	area_responsavel?: string;
	descricao_atividades?: string;
	matricula_responsavel_procedimento?: string;
	nome_responsavel_procedimento?: string;
	prazo_previsto_fim?: string;
	prazo_previsto_inicial?: string;
	prazo_real_fim?: string;
	prazo_real_inicial?: string;
	relatorio_inspecao?: string;
	uo_responsavel_procedimento?: string;

	file?: File | string;
	nome_arquivo?: string;
	historico?: IAnomaliasPut[];
	origem?: string,
	codigo_anomalia?: string,
}

export type AnomaliaList = {
	uuid?: string;
	estrutura: string;
	id_barragem: string;
	detalhes: IDetalhesAnomalia[];
}


export type FormErrors = any;

const create = async (data: any, uuid: string): Promise<any> => {
	await AuthService.verify();

	try {
		const token = await AuthService.getAccessToken();

		const response = await ApiBack.post(
			`./anomalia?uuid=${uuid}`,
			JSON.stringify(data),
			{
				headers: {
					'Content-Type': 'application/json',
					Authorization: `${token}`,
				},
			}
		);

		if (response.data) {
			return response.data;
		}

		return new Error('Erro ao criar anomalia.');
	} catch (error) {
		return new Error(
			(error as { message: string }).message || 'Erro ao criar anomalia.'
		);
	}
};

const list = async (uuid: string): Promise<IAnomalias[] | any> => {
	await AuthService.verify();

	try {
		const token = await AuthService.getAccessToken();

		const response = await ApiBack.get(`./anomalias?uuid=${uuid}`, {
			headers: {
				Authorization: `${token}`,
			},
		});

		if (response.data) {
			return response.data;
		}

		return new Error('Erro ao buscar plantas');
	} catch (error) {
		return new Error(
			(error as { message: string }).message || 'Erro ao buscar plantas'
		);
	}
};

const get = async (uuid: string): Promise<any> => {
	await AuthService.verify();

	try {
		const token = await AuthService.getAccessToken();

		const response = await ApiBack.get(`./anomalia?uuid=${uuid}`, {
			headers: {
				Authorization: `${token}`,
			},
		});

		if (response.data) {
			return response.data;
		}

		return new Error('Erro ao buscar plantas');
	} catch (error) {
		return new Error(
			(error as { message: string }).message || 'Erro ao buscar plantas'
		);
	}
};

const update = async (data: IAnomaliasPut, uuid: string): Promise<any> => {
	try {
		await AuthService.verify();
		const token = await AuthService.getAccessToken();

		const urlCompleta = `./anomalia?uuid=${uuid}&plano=true`;
		const response = await ApiBack.put(urlCompleta, data, {
			headers: {
				Authorization: `${token}`,
				'Content-Type': 'application/json',
			},
		});
		if (response.data) {
			return response.data;
		}
		return new Error('Erro ao atualizar anomalia: Resposta sem dados');
	} catch (error: any) {
		if (error.response && error.response.data && error.response.data.message) {
			return new Error(error.response.data.message);
		} else {
			return new Error(
				(error as { message: string }).message ||
					'Erro desconhecido ao atualizar anomalia'
			);
		}
	}
};

const delet = async (uuid: string): Promise<any> => {
	await AuthService.verify();

	try {
		const token = await AuthService.getAccessToken();

		const response = await ApiBack.delete(`./anomalia?uuid=${uuid}`, {
			headers: {
				Authorization: `${token}`,
			},
		});

		if (response.data) {
			return response.data;
		}

		return new Error('Erro ao buscar plantas');
	} catch (error) {
		return new Error(
			(error as { message: string }).message || 'Erro ao buscar plantas'
		);
	}
};

export const AnomalyService = {
	create,
	list,
	get,
	update,
	delet,
};
